import Link from "next/link";

interface LogoProps {
  /** Visual size: sm=16px/18svg, md=18px/22svg (default), lg=24px/32svg */
  size?: "sm" | "md" | "lg";
  /** Wrap in a Link. Pass false to render a plain div. Default: "/" */
  href?: string | false;
  style?: React.CSSProperties;
}

export default function Logo({ size = "md", href = "/", style }: LogoProps) {
  const svgSize = size === "sm" ? 18 : size === "lg" ? 32 : 22;
  const fontSize = size === "sm" ? 16 : size === "lg" ? 24 : 18;

  const inner = (
    <div style={{
      display: "flex", alignItems: "center", gap: 8,
      fontWeight: 900, fontSize,
      color: "#1a2b1d",
      ...style,
    }}>
      <svg width={svgSize} height={svgSize} viewBox="0 0 22 22" fill="none" style={{ flexShrink: 0 }}>
        <circle cx="11" cy="11" r="9" stroke="var(--green)" strokeWidth="1.5" />
        <circle cx="11" cy="11" r="5" stroke="var(--green)" strokeWidth="1.5" />
        <circle cx="11" cy="11" r="1.8" fill="var(--green)" />
        <circle cx="17" cy="5" r="2" fill="var(--green)" />
      </svg>
      <span>Lifer<span style={{ color: "var(--green)" }}>Radar</span></span>
    </div>
  );

  if (href === false) return inner;

  return (
    <Link href={href} style={{ textDecoration: "none", display: "inline-flex" }}>
      {inner}
    </Link>
  );
}
